const allEpisodesData = [
  {
    id: 1,
    heading:
      "Leveraging TikTok for Local Business With Rehan Pallithotungal of Ray Motion Films [The Videocraft Show Episode #52]",
    name: "",
    img: "latestEImg1.jpg",
    description1:
      "Short-form video is all the rage these days. But most small businesses don’t know how to leverage it.",
    description2: "Enter Ray of Ray Motion Films.",
    description3:
      "Ray Motion Films is a full-service digital marketing company based in New Jersey. And Ray has carved out a niche for himself in his local area, working mostly with companies providing financial services. He’s accomplished this by focusing on helping small business owners create “beautiful, unique, and thought-provoking projects”.",
    description4:
      "One of Ray’s greatest success stories to date has been his work with Badran Tax and Accounting, an accounting firm out of New Brunswick, New Jersey. With Ray’s guidance, Badran has managed to grow an audience of close to 100,000 followers on TikTok.",

    description5:
      "In this episode of The Videocraft Show Presented By Video Husky, Jon Santiago chats with Rehan about a variety of subjects including:",
    li1: "The origins of his interest in entrepreneurship.",
    li2: "How he thinks about pricing his services.",
    description6: "And much more...",
    italicLine1: "Is video editing slowing you down?",
    italicLine2:
      "Video Husky provides you access to a dedicated team of talented editors who can help.",
    url1: "https://www.youtube.com/watch?v=8HXcNmeCOoI",
  },
  {
    id: 2,
    heading:
      "Meet the Youtuber Making Money Helping Expats Move to Portugal (With Nick Robinson) [The Videocraft Show Episode #55]",
    name: "",
    img: "latestEImg2.jpg",
    description1:
      "Short-form video is all the rage these days. But most small businesses don’t know how to leverage it.",
    description2: "Enter Ray of Ray Motion Films.",
    description3:
      "Ray Motion Films is a full-service digital marketing company based in New Jersey. And Ray has carved out a niche for himself in his local area, working mostly with companies providing financial services. He’s accomplished this by focusing on helping small business owners create “beautiful, unique, and thought-provoking projects”.",
    description4:
      "One of Ray’s greatest success stories to date has been his work with Badran Tax and Accounting, an accounting firm out of New Brunswick, New Jersey. With Ray’s guidance, Badran has managed to grow an audience of close to 100,000 followers on TikTok.",

    description5:
      "In this episode of The Videocraft Show Presented By Video Husky, Jon Santiago chats with Rehan about a variety of subjects including:",
    li1: "The origins of his interest in entrepreneurship.",
    li2: "How he thinks about pricing his services.",
    description6: "And much more...",
    italicLine1: "Is video editing slowing you down?",
    italicLine2:
      "Video Husky provides you access to a dedicated team of talented editors who can help.",
    url1: "https://www.youtube.com/watch?v=8HXcNmeCOoI",
  },
  {
    id: 3,
    heading:
      "How Short-Form Video Helps This Real Estate Creator Generate Six-Figure Revenue [The Videocraft Show Episode #53]",
    name: "",
    img: "latestEImg3.jpg",
    description1:
      "Short-form video is all the rage these days. But most small businesses don’t know how to leverage it.",
    description2: "Enter Ray of Ray Motion Films.",
    description3:
      "Ray Motion Films is a full-service digital marketing company based in New Jersey. And Ray has carved out a niche for himself in his local area, working mostly with companies providing financial services. He’s accomplished this by focusing on helping small business owners create “beautiful, unique, and thought-provoking projects”.",
    description4:
      "One of Ray’s greatest success stories to date has been his work with Badran Tax and Accounting, an accounting firm out of New Brunswick, New Jersey. With Ray’s guidance, Badran has managed to grow an audience of close to 100,000 followers on TikTok.",

    description5:
      "In this episode of The Videocraft Show Presented By Video Husky, Jon Santiago chats with Rehan about a variety of subjects including:",
    li1: "The origins of his interest in entrepreneurship.",
    li2: "How he thinks about pricing his services.",
    description6: "And much more...",
    italicLine1: "Is video editing slowing you down?",
    italicLine2:
      "Video Husky provides you access to a dedicated team of talented editors who can help.",
    url1: "https://www.youtube.com/watch?v=8HXcNmeCOoI",
  },
  {
    id: 4,
    heading:
      "Leveraging TikTok for Local Business With Rehan Pallithotungal of Ray Motion Films [The Videocraft Show Episode #52]",
    name: "",
    img: "latestEImg1.jpg",
    description1:
      "Short-form video is all the rage these days. But most small businesses don’t know how to leverage it.",
    description2: "Enter Ray of Ray Motion Films.",
    description3:
      "Ray Motion Films is a full-service digital marketing company based in New Jersey. And Ray has carved out a niche for himself in his local area, working mostly with companies providing financial services. He’s accomplished this by focusing on helping small business owners create “beautiful, unique, and thought-provoking projects”.",
    description4:
      "One of Ray’s greatest success stories to date has been his work with Badran Tax and Accounting, an accounting firm out of New Brunswick, New Jersey. With Ray’s guidance, Badran has managed to grow an audience of close to 100,000 followers on TikTok.",

    description5:
      "In this episode of The Videocraft Show Presented By Video Husky, Jon Santiago chats with Rehan about a variety of subjects including:",
    li1: "The origins of his interest in entrepreneurship.",
    li2: "How he thinks about pricing his services.",
    description6: "And much more...",
    italicLine1: "Is video editing slowing you down?",
    italicLine2:
      "Video Husky provides you access to a dedicated team of talented editors who can help.",
    url1: "https://www.youtube.com/watch?v=8HXcNmeCOoI",
  },
  {
    id: 5,
    heading:
      "Leveraging TikTok for Local Business With Rehan Pallithotungal of Ray Motion Films [The Videocraft Show Episode #52]",
    name: "",
    img: "latestEImg1.jpg",
    description1:
      "Short-form video is all the rage these days. But most small businesses don’t know how to leverage it.",
    description2: "Enter Ray of Ray Motion Films.",
    description3:
      "Ray Motion Films is a full-service digital marketing company based in New Jersey. And Ray has carved out a niche for himself in his local area, working mostly with companies providing financial services. He’s accomplished this by focusing on helping small business owners create “beautiful, unique, and thought-provoking projects”.",
    description4:
      "One of Ray’s greatest success stories to date has been his work with Badran Tax and Accounting, an accounting firm out of New Brunswick, New Jersey. With Ray’s guidance, Badran has managed to grow an audience of close to 100,000 followers on TikTok.",

    description5:
      "In this episode of The Videocraft Show Presented By Video Husky, Jon Santiago chats with Rehan about a variety of subjects including:",
    li1: "The origins of his interest in entrepreneurship.",
    li2: "How he thinks about pricing his services.",
    description6: "And much more...",
    italicLine1: "Is video editing slowing you down?",
    italicLine2:
      "Video Husky provides you access to a dedicated team of talented editors who can help.",
    url1: "https://www.youtube.com/watch?v=8HXcNmeCOoI",
  },
  {
    id: 6,
    heading:
      "Leveraging Six TikTok for Local Business With Rehan Pallithotungal of Ray Motion Films [The Videocraft Show Episode #52]",
    name: "",
    img: "latestEImg6.jpg",
    description1:
      "Short-form video is all the rage these days. But most small businesses don’t know how to leverage it.",
    description2: "Enter Ray of Ray Motion Films.",
    description3:
      "Ray Motion Films is a full-service digital marketing company based in New Jersey. And Ray has carved out a niche for himself in his local area, working mostly with companies providing financial services. He’s accomplished this by focusing on helping small business owners create “beautiful, unique, and thought-provoking projects”.",
    description4:
      "One of Ray’s greatest success stories to date has been his work with Badran Tax and Accounting, an accounting firm out of New Brunswick, New Jersey. With Ray’s guidance, Badran has managed to grow an audience of close to 100,000 followers on TikTok.",

    description5:
      "In this episode of The Videocraft Show Presented By Video Husky, Jon Santiago chats with Rehan about a variety of subjects including:",
    li1: "The origins of his interest in entrepreneurship.",
    li2: "How he thinks about pricing his services.",
    description6: "And much more...",
    italicLine1: "Is video editing slowing you down?",
    italicLine2:
      "Video Husky provides you access to a dedicated team of talented editors who can help.",
    url1: "https://www.youtube.com/watch?v=8HXcNmeCOoI",
  },
  {
    id: 7,
    heading:
      "Leveraging TikTok for Local Business With Rehan Pallithotungal of Ray Motion Films [The Videocraft Show Episode #52]",
    name: "",
    img: "latestEImg7.jpg",
    description1:
      "Short-form video is all the rage these days. But most small businesses don’t know how to leverage it.",
    description2: "Enter Ray of Ray Motion Films.",
    description3:
      "Ray Motion Films is a full-service digital marketing company based in New Jersey. And Ray has carved out a niche for himself in his local area, working mostly with companies providing financial services. He’s accomplished this by focusing on helping small business owners create “beautiful, unique, and thought-provoking projects”.",
    description4:
      "One of Ray’s greatest success stories to date has been his work with Badran Tax and Accounting, an accounting firm out of New Brunswick, New Jersey. With Ray’s guidance, Badran has managed to grow an audience of close to 100,000 followers on TikTok.",

    description5:
      "In this episode of The Videocraft Show Presented By Video Husky, Jon Santiago chats with Rehan about a variety of subjects including:",
    li1: "The origins of his interest in entrepreneurship.",
    li2: "How he thinks about pricing his services.",
    description6: "And much more...",
    italicLine1: "Is video editing slowing you down?",
    italicLine2:
      "Video Husky provides you access to a dedicated team of talented editors who can help.",
    url1: "https://www.youtube.com/watch?v=8HXcNmeCOoI",
  },
  {
    id: 8,
    heading:
      "Leveraging 8 TikTok for Local Business With Rehan Pallithotungal of Ray Motion Films [The Videocraft Show Episode #52]",
    name: "",
    img: "latestEImg8.jpg",
    description1:
      "Short-form video is all the rage these days. But most small businesses don’t know how to leverage it.",
    description2: "Enter Ray of Ray Motion Films.",
    description3:
      "Ray Motion Films is a full-service digital marketing company based in New Jersey. And Ray has carved out a niche for himself in his local area, working mostly with companies providing financial services. He’s accomplished this by focusing on helping small business owners create “beautiful, unique, and thought-provoking projects”.",
    description4:
      "One of Ray’s greatest success stories to date has been his work with Badran Tax and Accounting, an accounting firm out of New Brunswick, New Jersey. With Ray’s guidance, Badran has managed to grow an audience of close to 100,000 followers on TikTok.",

    description5:
      "In this episode of The Videocraft Show Presented By Video Husky, Jon Santiago chats with Rehan about a variety of subjects including:",
    li1: "The origins of his interest in entrepreneurship.",
    li2: "How he thinks about pricing his services.",
    description6: "And much more...",
    italicLine1: "Is video editing slowing you down?",
    italicLine2:
      "Video Husky provides you access to a dedicated team of talented editors who can help.",
    url1: "https://www.youtube.com/watch?v=8HXcNmeCOoI",
  },
  {
    id: 9,
    heading:
      "Leveraging TikTok for Local Business With Rehan Pallithotungal of Ray Motion Films [The Videocraft Show Episode #52]",
    name: "",
    img: "latestEImg9.jpg",
    description1:
      "Short-form video is all the rage these days. But most small businesses don’t know how to leverage it.",
    description2: "Enter Ray of Ray Motion Films.",
    description3:
      "Ray Motion Films is a full-service digital marketing company based in New Jersey. And Ray has carved out a niche for himself in his local area, working mostly with companies providing financial services. He’s accomplished this by focusing on helping small business owners create “beautiful, unique, and thought-provoking projects”.",
    description4:
      "One of Ray’s greatest success stories to date has been his work with Badran Tax and Accounting, an accounting firm out of New Brunswick, New Jersey. With Ray’s guidance, Badran has managed to grow an audience of close to 100,000 followers on TikTok.",

    description5:
      "In this episode of The Videocraft Show Presented By Video Husky, Jon Santiago chats with Rehan about a variety of subjects including:",
    li1: "The origins of his interest in entrepreneurship.",
    li2: "How he thinks about pricing his services.",
    description6: "And much more...",
    italicLine1: "Is video may be editing slowing you down?",
    italicLine2:
      "Video Husky provides you access to a dedicated team of talented editors who can help.",
    url1: "https://www.youtube.com/watch?v=8HXcNmeCOoI",
  },
];

export default allEpisodesData;
